function isAddressValid({ address }) {
  if(!address) { return false }
  if(!address.match) { return false }
  return address.match(/^(xrb|nano)_[13][0-9a-km-uw-z]{59}$/g)
}

export default {
  isAddressValid
}